import React from 'react'
import Button from '@/components/button/button'
import { MainHeader, Row } from '@/components/layout/layout'

import './member-page-header.scss'

interface Props {
    title: string
    onBack: () => void
    backText?: string
    extra?: React.ReactNode
}

const MemberPageHeader: React.FC<Props> = ({ title, onBack, backText = '返回', extra }) => (
    <MainHeader>
        <Row className="member-page-header__main" data-align-items-center>
            <Button types="primary" onClick={onBack}>
                {backText}
            </Button>
            <span className="member-page-header__title">{title}</span>
        </Row>
        {extra ? <Row className="member-page-header__extra">{extra}</Row> : null}
    </MainHeader>
)

export default MemberPageHeader
